<template>
  <div>
    <span class="artist-name">{{ fullName }}</span>
    <span class="d-inline-block artist-birthnote pl-0">{{artistBirthnote}}</span>
  </div>
</template>

<script>
  export default {
    name: 'ArtistDetails',
    props: {
      artist: Object,
    },
    computed: {
      artistBirthnote() {
        if (this.artist.birthNote) {
          return this.artist.birthNote.includes('(') ? this.artist.birthNote : `(${this.artist.birthNote})`;
        }
        return '';
      },
      fullName() {
        if (this.artist.firstName === null) {
          return this.artist.lastName;
        } else if (this.artist.lastName === null) {
          return this.artist.firstName;
        }
        return `${this.artist.firstName} ${this.artist.lastName}`;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/shared/components/artist_details.vue?baa84a22